module.exports = __webpack_public_path__ + "img/032.2020969a.jpg";